import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import type { Card } from './card';

interface ConfirmRemoveCardDialogProps {
  /** `null` closes the dialog. Passing the card itself is what lets the copy
   *  name it, rather than asking "remove this card?" about nothing. */
  card: Card | null;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation before a card is removed.
 *
 * The destructive action is separated from Cancel by the row's full width on a
 * phone, and Cancel is what the thumb lands on first — the two must not sit
 * adjacent at 360px.
 *
 * Confirming closes this dialog immediately; progress belongs to the section
 * behind it, which a modal would otherwise hide from both eye and screen reader.
 */
export const ConfirmRemoveCardDialog = ({
  card,
  onCancel,
  onConfirm,
}: ConfirmRemoveCardDialogProps) => (
  <Dialog open={card !== null} onClose={onCancel} fullWidth maxWidth="xs">
    <DialogTitle>Remove this card?</DialogTitle>

    <DialogContent>
      <DialogContentText>
        {card === null
          ? null
          : `${card.brand} ending ${card.last4} will be removed from your account. Any payment already made with it is unaffected.`}
      </DialogContentText>
    </DialogContent>

    <DialogActions className="flex-col-reverse gap-2 p-4 sm:flex-row sm:justify-end">
      <Button onClick={onCancel} className="w-full sm:w-auto">
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        className="w-full sm:w-auto"
      >
        Remove card
      </Button>
    </DialogActions>
  </Dialog>
);
